import { render } from "./NewsTable.vue?vue&type=template&id=105d9f5a&scoped=true"
import script from "./NewsTable.vue?vue&type=script&lang=js"
export * from "./NewsTable.vue?vue&type=script&lang=js"

import "./NewsTable.vue?vue&type=style&index=0&id=105d9f5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-105d9f5a"

export default script